const TextTypes = {
    NORMAL: 'normal',
    SMALL: 'small',
    SECTION: 'section',
    SECTION_BLACK: 'section_black',
    LARGE: 'large',
    EXTRA_LARGE: 'extra_large',
    PARAGRAPH: 'p',
};

export default TextTypes;
